const SINGLE_TENANT_HOSTNAMES = ['enterprise.perplexity.ai'];
// for the majority of clien-side cases we should be using the useDevice hook
// if you are outside of context on server components, helper functions are provided
export const isPublicDNS = (hostname) => hostname?.includes('perplexity.ai') || hostname?.includes('perplexity.com');
export const isLocalhost = (hostname) => hostname?.includes('localhost');
export const isPplxDev = (hostname) => hostname?.includes('pplx.dev');
export const isPreview = (hostname) => isPublicDNS(hostname) && hostname?.includes('preview');
export const isStaging = (hostname) => isPublicDNS(hostname) && hostname?.includes('staging');
export const isBeta = (hostname) => isPublicDNS(hostname) && (hostname?.includes('alpha') || hostname?.includes('beta'));
export const isTesting = (hostname) => isPublicDNS(hostname) && hostname?.includes('testing');
export const isExperimental = (hostname) => isPublicDNS(hostname) && hostname?.includes('experimental');
export const isAskDev = (hostname) => isPublicDNS(hostname) && hostname?.includes('askdev');
export const isDevBox = (hostname) => isPublicDNS(hostname) &&
    (hostname?.startsWith('dev') || hostname?.endsWith('.devbox.p.perplexity.ai'));
// Keep in sync with agi/web/server/domain_utils.py
export const isNamedDevDomain = (hostname) => {
    return (isPublicDNS(hostname) &&
        (hostname?.includes('klarna') ||
            hostname?.includes('inhouse') ||
            hostname?.includes('wolfram') ||
            hostname?.includes('ftrouter') ||
            hostname?.includes('ft') ||
            hostname?.includes('brave') ||
            hostname?.includes('claude2') ||
            hostname?.includes('claude1-instant') ||
            hostname?.includes('claude2-instant') ||
            hostname?.includes('shopping') ||
            hostname?.includes('turbo16k') ||
            hostname?.includes('yelp') ||
            hostname?.includes('mobile-flag-dev')));
};
export const isProduction = (hostname) => isPublicDNS(hostname) &&
    !isPreview(hostname) &&
    !isTesting(hostname) &&
    !isBeta(hostname) &&
    !isAskDev(hostname) &&
    !isDevBox(hostname) &&
    !isNamedDevDomain(hostname) &&
    !isExperimental(hostname);
export const isSandbox = (hostname) => isPublicDNS(hostname) && hostname?.includes('sandbox');
export const isDevDeployment = (hostname) => hostname?.includes('quokka-gamma.ts.net') || // configured via tailscale
    hostname?.endsWith('.preview.i.perplexity.ai');
export const isSingleTenant = (hostname) => SINGLE_TENANT_HOSTNAMES.includes(hostname);
export const getDeployName = (hostname) => {
    const defaultName = 'unknown';
    try {
        if (process.env.DD_ENV) {
            return process.env.DD_ENV;
        }
        if (!hostname) {
            return defaultName;
        }
        if (isLocalhost(hostname)) {
            return 'local';
        }
        if (hostname === 'www.perplexity.ai' || hostname === 'www.perplexity.com') {
            return 'prod';
        }
        if (hostname.endsWith('.preview.i.perplexity.ai')) {
            return hostname.replace(/\.preview\.i\.perplexity\.ai$/, '');
        }
        if (hostname.endsWith('.perplexity.ai')) {
            return hostname.replace(/\.perplexity\.ai$/, '');
        }
        if (hostname.endsWith('.perplexity.com')) {
            return hostname.replace(/\.perplexity\.com$/, '');
        }
        return defaultName;
    }
    catch (_) {
        return defaultName;
    }
};
export const envHasDevLogins = (env) => env.isTesting ||
    env.isLocalhost ||
    env.isSandbox ||
    env.isDevBox ||
    env.isPplxDev ||
    env.isDevDeployment;
export const getEnv = (hostname, serverEnvironment) => {
    const env = {
        isPublicDNS: isPublicDNS(hostname),
        isLocalhost: isLocalhost(hostname),
        isPplxDev: isPplxDev(hostname),
        isPreview: isPreview(hostname),
        isStaging: isStaging(hostname),
        isBeta: isBeta(hostname),
        isTesting: isTesting(hostname),
        isAskDev: isAskDev(hostname),
        isDevBox: isDevBox(hostname),
        isNamedDevDomain: isNamedDevDomain(hostname),
        isProduction: isProduction(hostname),
        isSandbox: isSandbox(hostname),
        isDevDeployment: isDevDeployment(hostname),
        isSingleTenant: serverEnvironment === 'single-tenant' || isSingleTenant(hostname),
        deployName: getDeployName(hostname),
        envHasDevLogins: false,
        serverEnvironment,
    };
    env.envHasDevLogins = serverEnvironment !== 'single-tenant' && envHasDevLogins(env);
    return env;
};
/**
 * Resolves the environment from the hostname.
 * @returns 'beta' | 'staging' | 'testing' | 'local'
 */
export function resolveEnv() {
    if (isProduction(window.location.hostname)) {
        return 'beta';
    }
    if (isStaging(window.location.hostname)) {
        return 'staging';
    }
    if (isLocalhost(window.location.hostname)) {
        return 'local';
    }
    return 'testing';
}
//# sourceMappingURL=env.js.map